import { FormLayout } from "@shopify/polaris"
import Form from "components/widgets/CollectPage/forms/Form"
import React from "react"
import { useTranslation } from "react-i18next"
import CentralizedUploadMolecule from "views/molecules/upload/CentralizedUploadMolecule"
import { INVENTORY_PURCHASED_IT_SERVICES } from "utils/constants/centralization/inventoryItems"
import UploadOrganism from "views/organisms/upload/UploadOrganism"
import { Module } from "components/widgets/CollectPage/forms/Module"
import { useFormConfig } from "components/widgets/CollectPage/forms/FormContext"
import FileField from "components/widgets/CollectPage/forms/fields/FileField"
import TemplateFileLinkMolecule from "views/molecules/files/TemplateFileLinkMolecule"
import { PURCHASED_IT_SERVICES_COLLECT_MODULE } from "utils/constants/collects/modules"

const fields = []
const translationPath = "13.purchased_it_services"

const Objective13PurchasedITServicesForm = () => {
  const { t } = useTranslation()

  useFormConfig({ fields, translationPath })

  return (
    <Form>
      <FormLayout>
        <div className="columns">
          <div className="column">
            <FormLayout>
              <Module module={PURCHASED_IT_SERVICES_COLLECT_MODULE}>
                <UploadOrganism
                  centralisedComponent={
                    <CentralizedUploadMolecule
                      translationPathName="inventory_purchased_it_services"
                      inventoryType={INVENTORY_PURCHASED_IT_SERVICES}
                      displayDownloadIcon
                      displayQualityIcon
                      templateNameSuffix="purchased_it_services"
                      contextType="purchases"
                    />
                  }
                  decentralisedComponent={
                    <FileField
                      id="decentralized_inventory_purchased_it_services"
                      translationPathName="inventory_purchased_it_services"
                      inventoryType={INVENTORY_PURCHASED_IT_SERVICES}
                      title={t(
                        "collect:questions.13.purchased_it_services.inventory_purchased_it_services.label"
                      )}
                      precision={t(
                        "collect:questions.13.purchased_it_services.inventory_purchased_it_services.precision"
                      )}
                      displayDownloadIcon
                      displayQualityIcon
                      templateSelectionComponent={
                        <TemplateFileLinkMolecule id="inventory_template_local_purchased_it_services" />
                      }
                      contextType="purchases"
                    />
                  }
                />
              </Module>
            </FormLayout>
          </div>
        </div>
      </FormLayout>
    </Form>
  )
}

export default Objective13PurchasedITServicesForm
